"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _util = require("../../../util");
var _PaymentStyled = require("../PaymentStyled");
/* eslint-disable react/jsx-props-no-spreading */

var LegalCopy = function LegalCopy() {
  var CLEENG_TERMS_URL = 'CLEENG_TERMS_URL';
  var generateLinkAttributes = function generateLinkAttributes(href) {
    return {
      href: (0, _util.getData)(href),
      target: '_blank',
      rel: 'noreferrer',
      style: (0, _util.getData)(href) ? {
        textDecoration: 'underline'
      } : {}
    };
  };
  return /*#__PURE__*/_react.default.createElement(_PaymentStyled.LegalNoteWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentStyled.LegalTextStyled, {
    marginBottom: "24px"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "legal-notes-acknowledge"
  }, "By clicking 'Pay', I expressly acknowledge and agree to the full", ' ', /*#__PURE__*/_react.default.createElement("a", generateLinkAttributes(CLEENG_TERMS_URL), "Terms of Service"), ".")));
};
var _default = LegalCopy;
exports.default = _default;